<template>
  <div class="section-right-content-box" style="min-width: 1046px">
    <div class="box-shadow top-box">
      <div class="global-title cover">
        客户流失分析
        <el-button class="exportData" @click="exportData">导出数据</el-button>
      </div>
      <!-- 图表数据 -->
      <div style="padding: 0 28px 28px" v-loading="loading">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">数据图表</span>
        </div>
        <div
          id="order-care"
          :style="{ width: '100%', height: '400px' }"
        ></div>
        <!-- 列表表格 -->
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">数据报表</span>
        </div>
        <div style="margin-top: 30px">
          <el-table
            :data="lossData"
            border
            :header-cell-style="{background:'#fafafa', fontWeight: 700}"
            style="width: 100%">
            <el-table-column
              prop="range"
              label="最后一次购买时间"
              width="300">
            </el-table-column>
            <el-table-column
              prop="buyerCount"
              label="客户数量"
              width="300">
            </el-table-column>
            <el-table-column label="占比">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.rate"></el-progress>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120px">
              <template slot-scope="scope">
                <span class="titiecolor" @click="createCrow(scope.row)">生成人群</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

     <!-- 生成报表 -->
     <generate :control = 'control' 
               v-if="control" 
               @transData="(val) => (control = val)"
               @transData1 = 'getphone1'
               ></generate>
                   <!-- 生成人群 -->
    <crowdCreate 
      :isShow.sync="isShowCrowdDialog" 
      :crowdTag="crowdTag"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { lossAnalysis, exportData,exportDataOne } from "@/api/analysis/people_drain";
import generate from '../../components/generate_report.vue'
import crowdCreate from "@/components/crowd-create.vue";

export default {
  name: "monthly_report",
  data() {
    return {
      crowdTag: "",
      isShowCrowdDialog: false,
      control:false,
      lossX: [], // X轴
      lossY: [], // Y轴
      lossData: [], // 图表数据
      loading: true,
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
      recordData: [],
      people: 0,
      updataTime: "",
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  components: {
    generate,
    crowdCreate,
  },
  created() {
    this.lossAnalysis()

    // 埋点
    this.buriedPoint(1, '客户流失分析', '数据分析', '客户分析')
  },

  methods: {
    // 生成人群
    createCrow(data) {
      this.crowdTag = data.range
      this.isShowCrowdDialog = true
    },

    // 客户流失分析数据
    async lossAnalysis() {
      this.loading = true
      const { data } = await lossAnalysis()
      this.lossData = data
      data.forEach((item) => {
        this.lossX.push(item.buyerCount)
        this.lossY.push(item.range)
      })
      this.lossY = this.lossY.slice(0, this.lossY.length - 1)
      this.$nextTick(() => {
        this.drawOrderCareBar();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      });
      this.loading = false
     },
    async exportData() {
      this.control = true;
    },
    getphone1(val){
      let params = {
        exportRemark:val
      }
      exportDataOne(params).then((res)=>{
        if(res.code==1){
             this.control = true;
        }else{
          this.$message.error(res.message);
        }
      })
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          top: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          data: this.lossX,
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        yAxis: {
          type: "category",
          data: this.lossY,
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            data: this.lossX,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666",
                    fontSize: 14,
                  },
                },
                color: function (params) {
                  var colorList = [
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .titiecolor {
    cursor: pointer;
    color: #7f85e9;

    &:hover {
      color: #fe4d45;
    }
  }

  /deep/.el-progress-bar {
    padding-right: 70px;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    margin-right: -76px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  /deep/.el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #7e86ec;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

  .exportData {
    float: right;
    margin-top: 12px;
  }

  .cover {
    padding: 0 28px;
  }

  .choose {
    margin-top: 20px;
  }

  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
    @media screen and (max-width: 1400px) {
      margin-top: 10px;
      height: 280px;
    }
    @media screen and (max-width: 1340px) {
      margin-top: 10px;
      height: 250px;
    }

    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
    .chartheight {
      height: 300px;
      @media screen and (max-width: 1400px) {
        margin-top: 10px;
        height: 250px;
      }
      @media screen and (max-width: 1340px) {
        margin-top: 10px;
        height: 230px;
      }
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    margin-top: 26px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
}
</style>
